import { httpRequest } from "@services/http";
import type { AdGroup } from "@models/adGroup.model";

export interface UpdateAdGroupPayload {
  name?: string;
  audience_definition_id?: number | null;
  clear_audience?: boolean;
  /** Omitted leaves the choice alone; `networks` with follow=true is refused (MPN-1467). */
  follow_campaign_networks?: boolean;
  networks?: string[];
}

export class CommandUpdateAdGroup {
  async run(launchId: number, adGroupId: number, payload: UpdateAdGroupPayload): Promise<AdGroup> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/ad-groups/${adGroupId}/`;
    return httpRequest<AdGroup>(url, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  }
}
